
const baseColors = {
    slate1: '#EEF2F6',
    slate2: '#B6C8D9',
    slate3: '#A7B5C9',
    slate4: '#97A5BA',
    slate5: '#3D4751',
    blue1: '#0E2F9B',
    blue2: '#1838A3',
    blue3: '#2141ab',
    blue4: '#2E53CD',
    blue5: '#3B65EF',
};

const actionColors = {
    actionText: baseColors.blue1,
    actionHover: baseColors.slate1,
    actionPress: baseColors.slate2,
};

export type Theme = typeof baseColors & typeof actionColors;
export const theme: Theme = Object.assign({}, baseColors, actionColors);
